import api from './api';

const WALLET_PRODUCT_CODE = 'wallet-deposit';

export function prepareWalletDeposit() {
  return dispatch =>
    dispatch(api.get(`products/by-code/${WALLET_PRODUCT_CODE}`))
      .then(walletProductResponse => Promise.all([
        walletProductResponse,
        dispatch(api.post(`carts/`, {items: [{variant: walletProductResponse.content.variants[0].id, quantity: 1}]}))
      ]))
      .then(([walletProductResponse, walletCartResponse]) => ({
        walletProduct: walletProductResponse.content,
        walletCart: walletCartResponse.content
      }));
}

export function applyWalletDeposit(walletCart, walletProduct, quantity) {
  return dispatch =>
    dispatch(api.post(
      `carts/by-id/${walletCart.id}`,
      {items: [{variant: walletProduct.variants[0].id, quantity}]},
      {token: walletCart.tokenValue}
    ))
    .catch(checkoutError =>
      dispatch(discardWalletDeposit(walletCart)).then(() => {throw checkoutError;})
    )
}

export function checkoutWalletDeposit(walletCart, paymentMethod) {
  return dispatch =>
    dispatch(api.post(
      `carts/by-id/${walletCart.id}/checkout`,
      {payments: [{method: paymentMethod}]},
      {token: walletCart.tokenValue}
    ))
    .catch(checkoutError =>
      dispatch(discardWalletDeposit(walletCart)).then(() => {throw checkoutError;})
    )
}

export function discardWalletDeposit(walletCart) {
  return dispatch =>
    dispatch(api.delete(`carts/by-id/${walletCart.id}`, undefined, {token: walletCart.tokenValue}));
}



// WEBPACK FOOTER //
// ./ducks/wallet.js